import { useAuth } from "@/context/AuthContext";
import { useHousehold } from "@/context/HouseholdContext";

export const money = (v, currency = "EUR", locale = "fr-FR", opts = {}) =>
  v == null ? "—" : new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: 0, ...opts }).format(v);

export const shortDate = (iso, locale = "fr-FR") =>
  new Intl.DateTimeFormat(locale, { day: "numeric", month: "short" }).format(new Date(iso));

export function useFormat() {
  const { user } = useAuth();
  const { active } = useHousehold();
  const locale = user?.locale || "fr-FR";
  const currency = active?.currency || user?.currency || "EUR";
  return {
    locale,
    money: (v, o) => money(v, currency, locale, o),
    date: (d) => shortDate(d, locale),
    longDate: (d) => new Intl.DateTimeFormat(locale, { weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(d),
  };
}
